// BusOutstandingRequirement.js
import Vue from 'vue';
const FITValidationBus = new Vue();
export default FITValidationBus;


// WEBPACK FOOTER //
// ./src/components/Form/FITValidationBus.js